const $ = require('jquery');

window.$ = window.jQuery = $;

import 'bootstrap-datepicker';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker3.min.css';

//sweetalert2
window.Swal = require('sweetalert2');

window.bootstrap = require('bootstrap5/dist/js/bootstrap.min');
require('jquery-easy-loading/dist/jquery.loading.min');
require('jquery-validation/dist/jquery.validate.min');
try {
    require('jquery-validation/dist/localization/messages_' + $selectedLanguage + '.min');
} catch (err) {
}

jQuery.validator.setDefaults({
    ignore: ":hidden:not(select)",
    errorElement: "div",
    errorClass: "invalid-feedback",
    highlight: function (element) {
        $(element).closest(".form-control").addClass("is-invalid");
    },
    unhighlight: function (element) {
        $(element).closest(".form-control").removeClass("is-invalid");
    },
    errorPlacement: function (error, element) {
        if (element.parent(".input-group").length || element.prop("type") === "checkbox" || element.prop("type") === "radio") {
            error.insertAfter(element.parent());
        } else {
            error.insertAfter(element);
        }
    }
});

$(document).ready(function () {
    $('.form-validate').validate();
    $('.form-validate2').validate();

    $.fn.datepicker.dates['es'] = {
        days: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"],
        daysShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"],
        daysMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa", "Do"],
        months: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
        monthsShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
        today: "Hoy",
        clear: "Borrar",
        weekStart: 1,
        format: "dd/mm/yyyy"
    };
    $('.datepicker').datepicker({
        format: "dd/mm/yyyy",
        weekStart: 1,
        language: "es",
        autoclose: true,
        todayHighlight: true,
        endDate: "0d",
        maxViewMode: 2
    });

    $(document.body).on('click', '.modal-assistant', function (e) {
        e.preventDefault();
        modalLoading(true);
        let url = $(this).attr('data-url');
        $.ajax({
            method: 'GET',
            url: url
        }).done(function (data) {
            modalLoading(false);
            $('<div class="modal fade" id="infoModal" tabindex="-1" aria-labelledby="infoModalLabel" aria-hidden="true"><div class="modal-dialog modal-xl"><div class="modal-content"> ' + data + '</div></div></div>').modal('show');
        }).fail(function () {
            modalLoading(false);
            alert('Error inesperado. Recargue la página y vuelva a intentarlo.');
        });
    });

    function modalLoading(valid) {
        if (valid) {
            $('body').loading({
                theme: 'dark'
            });
        } else {
            $('body').loading('stop');
        }
    }

    $('#chooseLanguage').on('change', function () {
        console.log('12345');
        window.location.href = '/' + $(this).val();
    });
});

//desaparecer menu responsive del todo cuando estoy debajo del todo
/*$(document).ready(function(){
    $(window).scroll(function(){
        var scroll = $(document).height() - $(window).scrollTop() - $(window).height();
        if (scroll < 50) {
            $(".menu__private-area-responsive").addClass('hide');
        }

        else{
            $(".menu__private-area-responsive").removeClass('hide');
        }
    })
});*/

$(document).ready(function(){
    $(window).on("scroll resize", function(){
        var scrollTop = window.scrollY || window.pageYOffset; // Detectar el scroll vertical actual
        var windowHeight = window.innerHeight; // Altura visible de la ventana
        var documentHeight = $(document).height(); // Altura total del documento

        // Calcular cuánto falta para el final de la página
        var scroll = documentHeight - scrollTop - windowHeight;

        if (scroll < 50) {
            $(".menu__private-area-responsive").addClass('d-none');
        } else {
            $(".menu__private-area-responsive").removeClass('d-none');
        }
    });
});
